import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function SafetySecurityPage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-safety-security")!;
  return <ArticleLayout article={article} />;
}